module.exports = __webpack_public_path__ + "img/platforms.png.469a9252.webp";